import { createThunkAction } from "platopulse/lib/redux";

import PlatopulseAnalytics from "platopulse/lib/analytics";
import { PlatopulseApi } from "platopulse/services";

export const RESCAN_FIELD_VALUES = "platopulse/admin/fields/RESCAN_FIELD_VALUES";
export const DISCARD_FIELD_VALUES = "platopulse/admin/fields/DISCARD_FIELD_VALUES";

export const rescanFieldValues = createThunkAction(RESCAN_FIELD_VALUES, function(fieldId) {
    return async function(dispatch, getState) {
        try {
            let call = await PlatopulseApi.field_rescan_values({fieldId});
            PlatopulseAnalytics.trackEvent("Data Model", "Manual Re-scan Field Values");
            return call;
        } catch(error) {
            console.log('error manually re-scanning field values', error);
        }
    };
});

export const discardFieldValues = createThunkAction(DISCARD_FIELD_VALUES, function(fieldId) {
    return async function(dispatch, getState) {
        try {
            let call = await PlatopulseApi.field_discard_values({fieldId});
            PlatopulseAnalytics.trackEvent("Data Model", "Manual Discard Field Values");
            return call;
        } catch(error) {
            console.log('error discarding field values', error);
        }
    };
});



// WEBPACK FOOTER //
// ./admin/datamodel/field.js